export default "__VITE_ASSET__DGENzghK__"